import { ButtonHTMLAttributes, FC } from 'react';
import { twMerge } from 'tailwind-merge';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  id: string;
  color?: 'primary' | 'error' | 'success';
  variant?: 'contained' | 'outlined';
  hoverAnimations?: boolean;
};

/**
 * @todo Implementar outros tipos de cores.
 * @todo Implementar quando esta disabled.
 */
export const IconButton: FC<IconButtonProps> = ({
  id,
  color = 'primary',
  children,
  className,
  variant = 'contained',
  hoverAnimations = true,
  ...rest
}) => {
  return (
    <button
      id={id}
      className={twMerge(
        'rounded-full p-1.5 text-primary outline-none',
        'h-max w-max',
        'transition-all duration-300',
        hoverAnimations ? 'transform hover:-translate-y-0.5' : '',
        'focus:ring-2 focus:ring-primary focus:ring-offset-4',
        variant === 'contained' && color === 'primary' ? 'bg-primary text-white' : '',
        variant === 'contained' && color === 'error' ? 'bg-red-500 text-white focus:ring-red-500' : '',
        variant === 'contained' && color === 'success' ? 'bg-green-500 text-white focus:ring-green-500' : '',
        variant === 'outlined' && color === 'primary' ? 'text-primary' : '',
        variant === 'outlined' && color === 'error' ? 'text-red-500 focus:ring-red-500' : '',
        variant === 'outlined' && color === 'success' ? 'text-green-500 focus:ring-green-500' : '',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

